import { CanMatchFn } from '@angular/router';
import { environment } from '@env';

/**
 * Recruiter reports (R01-R07) ship dark behind `environment.reports`. As a `canMatch` guard, a
 * disabled flag makes `/reclutador/reportes` and every child route behave like any unknown URL.
 * The flag is read on every match, never cached at module load.
 */
export const reportsEnabledGuard: CanMatchFn = () => environment.reports;
